export default __webpack_public_path__ + "static/media/e-bupot-logotype-d.fe66248f.svg";